import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import {
  EmailTransactionLogStatus,
  SmsTransactionStatus,
  WhatsAppMessageTransactionLogStatus,
} from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'email-status',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './email-status.component.html',
})
export class EmailStatusComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  emailStatus = EmailTransactionLogStatus;
  smsTransactionLogStatus = SmsTransactionStatus;
  whatsappMessageTransactionLogStatus = WhatsAppMessageTransactionLogStatus;

  constructor() {}

  ngOnInit(): void {}
}
